import React from "react";
import Card from "../../../components/Card";
import { ICardInfoProps } from "./cardInfo.props";
import CountUp from "react-countup";

const CardInfoCom: React.FC<ICardInfoProps> = (
    {
        title,
        value,
        className,
        ...props
    }: ICardInfoProps
) => {
    return <Card className="p-[24px] flex flex-col basis-1/4 h-[96px]">
        <p className="text-[#1C1C1C] text-[0.75rem] font-normal ">{title}</p>
        <p className="text-[#1C1C1C] text-[1.5625rem] font-bold">
            <CountUp duration={1} className="counter" end={value} decimal="," />
        </p>
    </Card>
}

export default React.memo(CardInfoCom)